import React from 'react';
import styled from '@emotion/styled';
import logo from '../../static/logo/fb.png';
import logo2 from '../../static/logo/twitter.png';
import logo3 from '../../static/logo/insta.png';

const Wrapper = styled.h3`
    background-color: transparent;

`;

const Text = styled.div`
  margin: 0;
  padding-bottom: 2rem;
  text-align: center;
  color: ${props => props.theme.colors.white.light};
`;

const SocialMedia = () => (
  <Wrapper>
    <div className="row">
      <h3><a href="https://www.facebook.com/redboost.lk">
        <img src={logo} alt="Redboost fb Logo" />
        Facebook/redboost.lk</a>
      </h3>
      <h3><a href="https://twitter.com/RedboostLK">
        <img src={logo2} alt="Redboost Insta Logo" />
        Twitter/redboost.lk</a>
      </h3>
      <h3><a href="https://www.instagram.com/redboost.lk/">
        <img src={logo3} alt="Redboost Twitter Logo" />
        Instagram/redboost.lk</a>
      </h3>
      {/* <div className="twitter">
        <a className="twitter-timeline" href="https://twitter.com/RedboostLK?ref_src=twsrc%5Etfw">Tweets by RedboostLK</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
      </div> */}
    </div>
  </Wrapper>
);
export default SocialMedia;
